import Vue from "vue";
import Router from "vue-router";

import NormalPage from "@/components/pages/normal/normal.page.vue";
import RandomPage from "@/components/pages/random/random.page.vue";
import ScalePage from "@/components/pages/scale/scale.page.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			component: NormalPage,
			name: "NormalPage",
		},
		{
			path: "/random",
			component: RandomPage,
			name: "RandomPage",
		},
		{
			path: "/scale",
			component: ScalePage,
			name: "ScalePage",
		},
	]
})



// WEBPACK FOOTER //
// ./src/router.js